export default {
  searchText: '',
  searchSensorText: '',
  currentPage: 1,
  orderName: 'created_at',
  sortAsc: false
}
